/**
 * Displays a transient notification message within a toaster element.
 *
 * @param message - The message to display.
 * @param timeOut - Auto-hide duration in milliseconds (default: 10,000).
 */
export function toast(message: string, timeOut = 10000): void {
    // Get the primary toaster container. Selector migrated from the legacy
    // `<layout-viewport id="toaster">` custom tag to a standard `<div id="layout-toaster">`
    // (see any consumer's Pages/_Layout.cshtml + Static/Stylesheets/layout.scss).
    const toaster = document.querySelector<HTMLDivElement>('#layout-toaster');
    if (!toaster) return;

    // Get nested elements for displaying text and handling close
    const content = toaster.querySelector<HTMLDivElement>('div.content');
    const closeBtn = toaster.querySelector<HTMLButtonElement>('button.close');
    if (!content || !closeBtn) return;

    // Reset any previous close handler and show the toaster
    closeBtn.onclick = null;
    toaster.classList.add('open');
    content.innerHTML = message;

    // Auto-hide after the specified timeout
    const autoHideTimer = setTimeout(() => {
        toaster.classList.remove('open');
    }, timeOut);

    // Allow manual closing, which also clears auto-hide
    closeBtn.onclick = () => {
        toaster.classList.remove('open');
        clearTimeout(autoHideTimer);
    };
}

declare global {
    interface Window {
        toast: typeof toast;
        portalChildClick?: (this: HTMLElement, event: MouseEvent) => void;
    }
}

// Attach the toast function to the global window object
window.toast = toast;